import type { IconSvgObject } from './types';

const DrumIcon: IconSvgObject = [
  ["path", { d: "M14 4.1239C13.3568 4.04281 12.6874 4 12 4C7.02944 4 3 6.23858 3 9C3 11.7614 7.02944 14 12 14C16.9706 14 21 11.7614 21 9C21 8.65753 20.938 8.32311 20.82 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 9V16C21 18.7614 16.9706 21 12 21C7.02944 21 3 18.7614 3 16V9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8 14V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M16 14V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M12 9.5L21 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default DrumIcon;
